@let ctaFormGroup = ctaForm();

@if (ctaFormGroup) {
  <div class="mb-6 flex flex-col">
    <span class="text-2xl">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.kpisStep.title' | translate }}
    </span>
    <span class="text-shikenso-purple-base-60">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.kpisStep.description' | translate }}
    </span>
  </div>

  @if (customModeCreatorId()) {
    <div class="mb-6">
      {{
        'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.changesHereOnlyApplyTo'
          | translate: { creatorName: customModeCreatorName() }
      }}
    </div>
  }

  <app-execution-expected-kpi-list
    [formArray]="ctaFormGroup.controls.executions"
    [platformFeature]="selectedPlatformFeature()!"
    [availableKpis]="availableKpis()"
    [creatorId]="customModeCreatorId()"
    [isCustomMode]="!!customModeCreatorId()"
    [creators]="creators()"
    [isAllExpanded]="false"
    [isViewMode]="false"
    [ctaForm]="ctaFormGroup"
    [gamePlayValues]="gamePlayValues()"
  />
}
